import { BorrowTable } from '../components/borrow-table/BorrowTable'
import { CreatePositionPanel } from '../components/create-position-panel/CreatePositionPanel'
import { DepositTable } from '../components/deposit-table/DepositTable'
import { MyWalletPanel } from '../components/my-wallet-panel/MyWalletPanel'
import { Position } from '../components/position/Position'
import { Borrow, Deposit } from '../logic/assets'
import { PositionSummary } from '../logic/types'
import { WalletCompositionInfo } from '../logic/wallet-composition'
import { OpenDialogFunction } from '@/domain/state/dialogs/slice'
import { EModeCategoryId } from '@/features/sparklend/common/data/market-info/emode'
import { LiquidationDetails } from '@/features/sparklend/common/data/market-info/getLiquidationDetails'
import { Panel } from '@/ui/atoms/panel/Panel'
import { PageLayout } from '@/ui/layouts/PageLayout'
import { HealthFactorPanelContent } from '@/ui/molecules/health-factor-panel-content/HealthFactorPanelContent'

export interface PositionViewProps {
  positionSummary: PositionSummary
  deposits: Deposit[]
  borrows: Borrow[]
  eModeCategoryId: EModeCategoryId
  walletComposition: WalletCompositionInfo
  openDialog: OpenDialogFunction
  liquidationDetails: LiquidationDetails | undefined
  chainId: number
}

export function PositionView({
  positionSummary,
  deposits,
  borrows,
  eModeCategoryId,
  walletComposition,
  openDialog,
  liquidationDetails,
  chainId,
}: PositionViewProps) {
  const hf = positionSummary.healthFactor

  return (
    <PageLayout>
      <div className="flex flex-col gap-6 xl:grid xl:grid-cols-[67%_calc(33%-18px)] xl:gap-[18px]">
        <div className="order-2 flex flex-col gap-6 xl:order-1">
          <div className="flex flex-col flex-wrap gap-4 md:flex-row">
            <Position className="order-3 grow md:order-2" positionSummary={positionSummary} />
            {!positionSummary.hasDeposits && <CreatePositionPanel className="order-2 grow md:order-3" />}
          </div>
          <DepositTable assets={deposits} openDialog={openDialog} chainId={chainId} />
          <BorrowTable assets={borrows} eModeCategoryId={eModeCategoryId} openDialog={openDialog} chainId={chainId} />
        </div>
        <div className="order-1 flex flex-col gap-6 md:grid md:grid-cols-2 xl:order-2 xl:flex xl:flex-col">
          <Panel variant="secondary">
            <HealthFactorPanelContent hf={hf} liquidationDetails={liquidationDetails} />
          </Panel>
          <MyWalletPanel {...walletComposition} />
        </div>
      </div>
    </PageLayout>
  )
}
